document.documentElement.classList.add('js');

document.querySelectorAll('[data-nav-toggle]').forEach((button) => {
  const targetId = button.getAttribute('aria-controls');
  const target = document.getElementById(targetId);

  if (!target) return;

  button.addEventListener('click', () => {
    const expanded = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', String(!expanded));
    target.classList.toggle('is-open', !expanded);
  });
});

document.querySelectorAll('[data-faq-trigger]').forEach((button) => {
  const answerId = button.getAttribute('aria-controls');
  const answer = document.getElementById(answerId);

  if (!answer) return;

  button.addEventListener('click', () => {
    const expanded = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', String(!expanded));
    answer.hidden = expanded;
    button.closest('.faq-item')?.classList.toggle('is-open', !expanded);
  });
});
